import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { combineLatest, forkJoin, map, mergeMap, Observable, Subscription, switchMap } from 'rxjs';
import { Globals } from 'src/app/shared/globals';
import { SideNavbarService } from 'src/app/side-navbar/side-navbar.service';
import { EducationService } from '../education.service';
import { TextService } from '../../shared/text.service';
import { environment } from '../../../environments/environment';
//import { EducationsByEducationTypeAndOrganisationComponent } from "../education.module";

@Component({
  selector: 'education-types-by-organisation',
  templateUrl: './education-types-by-organisation.component.html',
  styleUrls: ['./education-types-by-organisation.component.css']
})
export class EducationTypesByOrganisationComponent implements OnInit {

  educationTypeId!: any;
  @Input('organisation-unit-id') organisationUnitId!: any;
  @Input('period') period!: any;
  //period: any;
  id: any;
  units: any;
  isLoaded = false;
  //@Output() educationsLoaded = false;
  header!: any;
  educations!: any;
  educationTypes!: any;
  educationType!: any;
  panelOpenState = false;
  private subscription: Subscription = new Subscription();

  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private navigationService: SideNavbarService,
    private textService: TextService,
    private educationService: EducationService,
    private titleService: Title
  ) {
    //tämä ilmeisesti estää koulutusten latautumisen back-painalluksen yhteydessä?
    route.params.subscribe(params => {

      this.subscription.unsubscribe();
      this.subscription = new Subscription();
      this.ngOnInit();
    })
    /*this.subscription.add(this.router.events.subscribe((e: any) => {
            // If it is a NavigationEnd event re-initalise the component
        if (e instanceof NavigationEnd) {
          console.log('haetaan uusiksi');
          this.getEducations();
        }
      }));*/
   }

  ngOnInit(): void {
    // tällä saadaan aikaan latauspalkki
    this.subscription.add(this.route.url.subscribe(url => {
      this.isLoaded = false;
    }));
    
    this.subscription.add(this.textService.getText('educations').subscribe(
      value => this.header = value
    ));
          

    let observables: Observable<any>[] = [];

    this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
      organisationId: params[0].get('organisation-unit-id'), 
      period: params[1].get('period')
      })),
      map(params => {
      this.organisationUnitId = params.organisationId;
      this.period = params.period;
      })
    ).subscribe());

    this.subscription.add(this.educationService.getEducationTypesByOrganisation(this.organisationUnitId).pipe(
      map(educationTypes =>{
        this.educationTypes = educationTypes;
        
        //haetaan koulutukset rinnakkain ja päivitetään latauspalkki
        educationTypes.forEach((unit: { children: any; id: any; }) => {
          
          const observable = this.educationService.getEducationsByEducationTypeAndOrganisation(this.organisationUnitId, unit.id);
          observable.subscribe(educations => {
            unit.children = educations
            this.educations = educations;
            //sortataan
            this.globals.sortByName2(educations, this.globals.lang);
            this.educations.forEach((education: { children: any[]; }) => {
              this.globals.sortByName2(education.children, this.globals.lang);
            })
          })
          observables.push(observable)

        });
        
        forkJoin(observables).subscribe(allResult => this.isLoaded = true);
      })
    ).subscribe());

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  
  /**
     * Päätellääm koulutus kaksiportaiseksi, jos se sisältää ainakin yhden 
     * BA-tasoisen ja ainakin yhden muu-tasoisen tutkinnon.
     * @param units 
     */
   isTwoCycleDegree(units: any[]) {
      
    let bachelor = false;
    let other = false;
    units.forEach(unit => {
      if (unit.educationLevel != null) {
        if(unit.educationLevel == 'BA') {
          bachelor = true;
        } else {
          other = true;
        }
      }
    });
    //console.log(bachelor);
    return bachelor && other;
  }

  /*setTitle() {
    console.log('huhuu');
    //console.log(this?.educationType)
    if (this.period) {
      this.titleService.setTitle(this.globals.getLocalizedValue(this.educationType.name) + ' | ' + this.globals.getLocalizedValue(this.header) + environment.titleExtension + ' ' + this.period);
    } else {
      this.titleService.setTitle(this.globals.getLocalizedValue(this.educationType.name) + environment.titleExtension);
    }
  }*/

  setCurrentUrl() {
    
      if (!this.period) {
        this.globals.currentUrl = {
          valueFi:'/fi/' + this.globals.toKebabCase(this.educationType.name.valueFi) + '/' + this.educationType.id, 
          valueEn:'/en/' + this.globals.toKebabCase(this.educationType.name.valueEn) + '/' + this.educationType.id, 
          valueSv:'/sv/' + this.globals.toKebabCase(this.educationType.name.valueSv) + '/' + this.educationType.id
        };
      } else {           
        this.globals.currentUrl = {
          valueFi:'/fi/' + this.globals.toKebabCase(this.educationType.name.valueFi) + '/' + this.educationType.id + '?period=' + this.period, 
          valueEn:'/en/' + this.globals.toKebabCase(this.educationType.name.valueEn) + '/' + this.educationType.id + '?period=' + this.period, 
          valueSv:'/sv/' + this.globals.toKebabCase(this.educationType.name.valueSv) + '/' + this.educationType.id + '?period=' + this.period
        }
      }
    //this.globals.createLinkForCanonicalURL();
  } //end of setCurrentUrl()


}
